import { handleResultadosGeraisStrategy } from "./gerais";
import { handleEvolutivoStrategy } from "./evolutivo";
import { handleCruzamentoStrategy } from "./cruzamento";

export const strategies = {
  GERAIS: (plotData, viewConfigData, order) => handleResultadosGeraisStrategy(plotData, viewConfigData, order),
  EVOLUTIVO: (plotData, viewConfigData) => handleEvolutivoStrategy(plotData, viewConfigData),
  CRUZAMENTO_SIMPLES: (plotData, viewConfigData) => handleCruzamentoStrategy(plotData, viewConfigData),
}


